/*
* Error Handler 
* and Reload after deploy (fix "error loading dynamically imported module")
*/
export default defineNuxtPlugin((nuxtApp) => {
  const reloadErrorList = [
    'error loading dynamically imported module',
    'Importing a module script failed',
    'Failed to fetch dynamically imported module'
  ]
    
  /*
  * Reload App after Build
  */
  nuxtApp.hook('app:chunkError', (error) => {
    const message = error?.error?.message || ''
    const filePath = error?.error?.stack || ''

    const shouldReload = reloadErrorList.some((msg) => message.toLowerCase().includes(msg.toLowerCase()))
    const isNuxtChunk = message.includes('/_nuxt/') || filePath.includes('/_nuxt/')
    if (shouldReload && isNuxtChunk) {
      console.warn('🔁 Reloading due to chunk error in /_nuxt/')

      setTimeout(() => {
        // window.location.reload(true)
      }, 500)
    }
  })

  /*
  * Error Handler
  */
  // problem with https://www.customusb.com/product/audio-link-true-wireless-earbuds-349 on server
  // const originalErrorHandler = nuxtApp.vueApp.config.errorHandler

  nuxtApp.vueApp.config.errorHandler = (error) => {
    const message = error?.message || ''

    if (message.includes('isValidChild')) return
    if (message.includes('Failed to load resource: the server responded with a status of 404')) return
    if (message.includes('Refused to execute script from')) return
    if (message.includes('parentNode') || message.includes('nodeType')) return
    if (message.includes('getRng') || message.includes('setContent')) return
    if (reloadErrorList.some((phrase) => message.toLowerCase().includes(phrase.toLowerCase()))) return

    // if (typeof originalErrorHandler === 'function') {
    //   originalErrorHandler(error, vm, info)
    // } else {
    //   console.error(error)
    // }

    console.error(error)
  }
})
